import httpUtils from '../utils/http-utils';
import { API_PATH } from '../config/app-config';

// Footer Layer C settings (NMU-421): /api/v1/admin/footer-settings
const SERVICE_NAME = API_PATH.FOOTER_SETTINGS;

const get = () => {
    return httpUtils.get(SERVICE_NAME);
}

const save = (bean) => {
    return httpUtils.put(SERVICE_NAME, bean);
}

const footerSettingsApi = {
    get,
    save,
}

export default footerSettingsApi;
